
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes03Off as ObiDiodes03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-03-off.js';
 
 
 

 
 export const ObiDiodes03Off = createComponent({
   react: React,
   tagName: 'obi-diodes-03-off',
   elementClass: ObiDiodes03OffElement,
   events: {
     
   }
  });
 
 